export const formBuilder = {
  title: 'Forms & Lists Builder',
  subtitle: 'Create custom forms for data collection and lists for data display',
  fieldPalette: 'Field Palette',
  fieldPaletteDescription: 'Drag fields to canvas or click to add',
  untitledForm: 'Untitled Form',
  untitledList: 'Untitled List',
  selectField: 'Select a field to edit its properties',
  selectFieldDescription: 'Choose a field from the canvas to customize its properties and settings',
  clickToEdit: 'Click to edit',
  editTitle: 'Edit title',
  sectionNamePlaceholder: 'Enter section name...',
  dragToReorder: 'Drag to reorder',
  unassignedFields: 'Unassigned Fields',
  unassignedFieldsDescription: 'Fields not assigned to any section - drag them to sections',
  validationHelpText: 'No validation rules set. Add rules to validate user input.',

  confirmDelete: {
    title: 'Delete Field',
    message: 'Are you sure you want to delete this field? This action cannot be undone.',
    confirm: 'Delete Field'
  },

  confirmDeleteSection: {
    title: 'Delete Section',
    message: 'Are you sure you want to delete this section and all its fields? This action cannot be undone.',
    confirm: 'Delete Section'
  },
  confirmDeleteTemplate: {
    title: 'Delete Template',
    message: 'Are you sure you want to delete this template? This action cannot be undone.',
    confirm: 'Delete Template'
  },

  quickGuide: {
    formsTitle: 'Create Your First Form',
    formsDescription: 'Forms allow you to collect data from users. You can add various field types like text, email, dropdowns, and more.',
    listsTitle: 'Create Your First List',
    listsDescription: 'Lists allow you to display collected data in organized tables. You can customize columns, add filters, and format data display.'
  },
  newForm: 'New Form',
  preview: 'Preview',
  settings: 'Settings',
  forms: 'Forms',
  searchPlaceholder: 'Search templates...',
  emptyForm: 'No fields yet',
  emptyFormDescription: 'Drag fields from the palette to get started',
  emptySection: 'No fields in this section',
  emptySectionDescription: 'Drag fields here to add them to this section',
  emptySectionDescriptionCross: 'Drag fields from palette or other sections here',
  dropFieldHere: 'Drop field here',
  dropHere: 'Drop field here',
  addSection: 'Add Section',
  
  categories: {
    basic: 'Basic Fields',
    advanced: 'Advanced Fields',
    lookup: 'Lookup Fields',
    special: 'Special Fields'
  },
  
  fieldTypes: {
    text: 'Text Input',
    email: 'Email',
    phone: 'Phone',
    number: 'Number',
    currency: 'Currency',
    percentage: 'Percentage',
    date: 'Date',
    datetime: 'Date & Time',
    time: 'Time',
    textarea: 'Text Area',
    select: 'Dropdown',
    multiselect: 'Multi Select',
    radio: 'Radio Buttons',
    checkbox: 'Checkboxes',
    switch: 'Toggle Switch',
    file: 'File Upload',
    image: 'Image Upload',
    color: 'Color Picker',
    range: 'Range Slider',
    rating: 'Star Rating',
    signature: 'Signature',
    address: 'Address',
    customer_lookup: 'Customer Lookup',
    product_lookup: 'Product Lookup',
    user_lookup: 'User Lookup',
    organization_lookup: 'Organization Lookup',
    custom_object: 'Custom Object'
  },

  fieldDescriptions: {
    text: 'Single line text input',
    email: 'Email address with validation',
    phone: 'Phone number input',
    number: 'Numeric input',
    currency: 'Currency amount',
    percentage: 'Percentage value',
    date: 'Date picker',
    datetime: 'Date and time picker',
    time: 'Time picker',
    textarea: 'Multi-line text input',
    select: 'Single selection dropdown',
    multiselect: 'Multiple selection dropdown',
    radio: 'Single choice radio buttons',
    checkbox: 'Multiple choice checkboxes',
    switch: 'On/off toggle',
    file: 'File upload field',
    image: 'Image upload with preview',
    color: 'Color selection',
    range: 'Numeric range slider',
    rating: 'Star rating input',
    signature: 'Digital signature pad',
    address: 'Address input with autocomplete',
    customer_lookup: 'Search and select customer',
    product_lookup: 'Search and select product',
    user_lookup: 'Search and select user',
    organization_lookup: 'Search and select organization',
    custom_object: 'Custom object'
  },
  
  properties: {
    title: 'Field Properties',
    general: 'General',
    validation: 'Validation',
    options: 'Options',
    appearance: 'Appearance',
    incompatibleRule: 'This rule is not compatible with the current field type',
    validationHelpText: 'Rules available for this field type',
    conditional: 'Conditional Logic',
    fields: 'fields',
    
    label: 'Label',
    name: 'Field Name',
    placeholder: 'Placeholder',
    description: 'Description',
    required: 'Required',
    defaultValue: 'Default Value',
    width: 'Width',
    
    validationRules: 'Validation Rules',
    addValidation: 'Add Validation',
    validationRule: 'Rule',
    validationValue: 'Value',
    validationMessage: 'Error Message',
    minLength: 'Minimum Length',
    maxLength: 'Maximum Length',
    minValue: 'Minimum Value',
    maxValue: 'Maximum Value',
    pattern: 'Pattern',
    customValidation: 'Custom Validation',
    category: 'Category',
    categoryPlaceholder: 'Enter category...',
    tags: 'Tags',
    tagsPlaceholder: 'Enter tags separated by commas...',
    fileSettings: 'File Settings',
    multipleFiles: 'Allow multiple files',
    maxFileSize: 'Max File Size (MB)',
    acceptedTypes: 'Accepted File Types',
    acceptedTypesHelp: 'Use MIME types (e.g., image/*) or file extensions (e.g., .pdf,.doc)',
    hidden: 'Hidden field',
    
    optionValue: 'Value',
    optionLabel: 'Label',
    addOption: 'Add Option',
    removeOption: 'Remove Option',
    noOptions: 'No options added yet. Click "Add Option" to get started.',
    
    fieldWidth: {
      full: 'Full Width',
      half: 'Half Width',
      third: 'Third Width',
      quarter: 'Quarter Width'
    },
    
    widthFull: 'Full Width',
    widthHalf: 'Half Width',
    widthThird: 'Third Width',
    widthQuarter: 'Quarter Width'
  },
  
  validation: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    min: 'Minimum value is {{min}}',
    max: 'Maximum value is {{max}}',
    minLength: 'Minimum length is {{minLength}} characters',
    maxLength: 'Maximum length is {{maxLength}} characters',
    pattern: 'Invalid format',
    checkboxRequired: 'This checkbox must be checked',
    switchRequired: 'This switch must be enabled'
  },

  share: {
    title: 'Share Form',
    description: 'Share this form with others',
    publicAccess: 'Public Access',
    publicEnabled: 'Anyone with the link can fill this form',
    publicDisabled: 'Only authorized users can access this form',
    publicLink: 'Public Link',
    settings: 'Sharing Settings',
    allowAnonymous: 'Allow anonymous submissions',
    allowAnonymousDesc: 'Users can submit without providing their email',
    requireEmail: 'Require email address',
    requireEmailDesc: 'Users must provide their email to submit',
    maxSubmissions: 'Maximum submissions (optional)',
    unlimited: 'Unlimited',
    submitted: 'submitted',
    enabled: 'Public sharing enabled',
    disabled: 'Public sharing disabled'
  },

  publicForm: {
    error: 'Form Unavailable',
    submitSuccess: 'Form Submitted Successfully!',
    submitSuccessMessage: 'Thank you for your submission. Your response has been recorded.'
  },
  
  messages: {
    createSuccess: 'Form template created successfully',
    createSuccessWithList: 'Form template and default list created successfully',
    updateSuccess: 'Form template updated successfully',
    deleteSuccess: 'Template deleted successfully',
    duplicateSuccess: 'Template duplicated successfully',
    defaultListError: 'Could not create default list',
    noListsForForm: 'No lists found for this form. Create one first.',
    listsLoaded: 'Lists loaded for this form',
    loadListsError: 'Failed to load lists for this form'
  },

  templates: {
    createList: 'Create List',
    viewLists: 'View Lists',
    duplicate: 'Duplicate',
    noTemplates: 'No templates found',
    createFirst: 'Create your first template to get started',
    lastModified: 'Last modified',
    createdBy: 'Created by',
    version: 'Version',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    export: 'Export',
    import: 'Import'
  },

  listViewer: {
    viewData: 'View Data',
    noData: 'No submissions found',
    noDataDescription: 'Submissions will appear here once the form is filled out',
    submissions: 'submissions',
    submission: 'submission',
    from: 'from',
    submittedBy: 'Submitted by',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    results: 'results',
    search: 'Search...',
    filters: 'Filters',
    export: 'Export',
    actions: 'Actions',
    loadError: 'Failed to load list',
    loadSubmissionsError: 'Failed to load submissions',
    notFound: 'List not found',
    notFoundDescription: 'The requested list could not be found'
  },
  
  errors: {
    loadFailed: 'Failed to load templates',
    saveFailed: 'Failed to save template',
    deleteFailed: 'Failed to delete template',
    invalidField: 'Invalid field configuration'
  },

  sectionProperties: {
    title: 'Section Properties',
    basic: 'Basic Properties',
    appearance: 'Appearance',
    order: 'Section Order',
    color: 'Section Color',
    collapsible: 'Collapsible section',
    moveUp: 'Move Up',
    moveDown: 'Move Down'
  },

  formSettings: {
    title: 'Form Settings',
    subtitle: 'Configure your form behavior and appearance',
    general: 'General Settings',
    appearance: 'Appearance Settings', 
    permissions: 'Permissions Settings',
    generalTab: 'General',
    appearanceTab: 'Appearance',
    permissionsTab: 'Permissions',
    basicInfo: 'Basic Information',
    formBehavior: 'Form Behavior',
    displaySettings: 'Display Settings',
    accessControl: 'Access Control',
    formTitle: 'Form Title',
    formDescription: 'Form Description',
    submitButtonText: 'Submit Button Text',
    cancelButtonText: 'Cancel Button Text',
    allowDrafts: 'Allow saving drafts',
    multiStep: 'Multi-step form',
    showProgressBar: 'Show progress bar',
    canView: 'Who can view this form?',
    canEdit: 'Who can edit this form?',
    canSubmit: 'Who can submit this form?',
    permissionsHelp: 'Permissions format:'
  }
};

export const formRenderer = {
  templateNotFound: 'Form template not found',
  loadError: 'Error loading form template',
  submitSuccess: 'Form submitted successfully',
  submitError: 'Error submitting form',
  noTemplate: 'No form template available'
};

export const formFiller = {
  title: 'Fill Form',
  subtitle: 'Complete the form below',
  templateNotFound: 'Form template not found',
  noPermission: 'You do not have permission to fill this form',
  notAvailableOnPortal: 'This form is not available on the customer portal',
  noAccess: 'You do not have access to this form',
  loadError: 'Error loading form template',
  errorTitle: 'Unable to Load Form',
  draftSaved: 'Draft saved successfully',
  submitted: 'Form Submitted Successfully!',
  submitSuccessMessage: 'Thank you for your submission. Your response has been recorded.',
  submitError: 'Failed to submit form. Please try again.'
};

export const formSubmissions = {
  title: 'Form Submissions',
  subtitle: 'Manage and review form submissions',
  loadError: 'Error loading form submissions',
  searchPlaceholder: 'Search submissions...',
  allStatuses: 'All Statuses',
  draft: 'Draft',
  submitted: 'Submitted',
  approved: 'Approved',
  rejected: 'Rejected',
  processing: 'Processing',
  noSubmissions: 'No submissions found',
  noResults: 'No submissions match your filters',
  noSubmissionsYet: 'No form submissions have been created yet',
  form: 'Form',
  submittedBy: 'Submitted By',
  status: 'Status',
  submittedAt: 'Submitted',
  actions: 'Actions',
  approveSubmission: 'Approve Submission',
  rejectSubmission: 'Reject Submission',
  reviewNotes: 'Review Notes (Optional)',
  reviewNotesPlaceholder: 'Add notes about your decision...',
  approve: 'Approve',
  reject: 'Reject',
  approveSuccess: 'Submission approved',
  rejectSuccess: 'Submission rejected',
  reviewError: 'Error reviewing submission'
};

export const myForms = {
  title: 'My Forms',
  subtitle: 'Forms you created and can fill out',
  loadError: 'Error loading forms',
  searchPlaceholder: 'Search your forms...',
  createNew: 'Create New Form',
  createFirst: 'Create Your First Form',
  noForms: 'No forms created yet',
  noFormsDescription: 'Create your first form to get started',
  noResults: 'No forms match your filters',
  noResultsDescription: 'Try adjusting your search or filters',
  fields: 'fields',
  submissions: 'submissions',
  fill: 'Fill',
  filters: {
    all: 'All Forms',
    available: 'Available to Fill',
    draft: 'With Drafts',
    submitted: 'Submitted',
    completed: 'Completed'
  },
  status: {
    available: 'Available to Fill',
    draft: 'Draft Saved',
    submitted: 'Submitted',
    approved: 'Approved',
    rejected: 'Rejected',
    processing: 'Processing'
  }
};

export const listBuilder = {
  title: 'List Builder',
  preview: 'Preview',
  newList: 'New List',
  lists: 'Lists',
  columns: 'Columns',
  filters: 'Filters',
  settings: 'Settings',
  untitledList: 'Untitled List',
  listName: 'List Name',
  listDescription: 'List Description',
  noColumns: 'No Columns Added',
  addColumnsFromPalette: 'Add columns from the palette on the left to start building your list',
  columnTypesTitle: 'Column Types',
  dragColumnTypes: 'Click column types to add them to your list',
  selectColumn: 'Select a Column',
  selectColumnDescription: 'Choose a column from the table to customize its properties',
  columnProperties: 'Column Properties',
  columnLabel: 'Label',
  fieldName: 'Field Name',
  columnWidth: 'Width (px)',
  columnOptions: 'Options',
  formatting: 'Formatting',
  comingSoon: 'List Builder Coming Soon',
  comingSoonDescription: 'The list builder is currently under development. This will allow you to create custom data tables and views.',
  previewComingSoon: 'List Preview Coming Soon',
  previewComingSoonDescription: 'Preview functionality will be available once the list builder is complete.',
  
  columnTypes: {
    text: 'Text',
    number: 'Number',
    currency: 'Currency',
    date: 'Date',
    datetime: 'Date & Time',
    boolean: 'Yes/No',
    status: 'Status',
    priority: 'Priority',
    progress: 'Progress',
    image: 'Image',
    link: 'Link',
    actions: 'Actions'
  },
  
  properties: {
    field: 'Field',
    label: 'Label',
    type: 'Type',
    width: 'Width',
    sortable: 'Sortable',
    filterable: 'Filterable',
    searchable: 'Searchable',
    format: 'Format',
    prefix: 'Prefix',
    suffix: 'Suffix'
  },
  
  messages: {
    createSuccess: 'List template created successfully',
    updateSuccess: 'List template updated successfully'
  },

  quickGuide: {
    listsTitle: 'Create Your First List',
    listsDescription: 'Lists allow you to display collected data in organized tables. You can customize columns, add filters, and format data display.'
  },

  listViewer: {
    notFound: 'List not found',
    notFoundDescription: 'The requested list could not be found',
    loadError: 'Error loading list',
    loadSubmissionsError: 'Error loading submissions',
    submission: 'submission',
    submissions: 'submissions',
    search: 'Search...',
    filters: 'Filters',
    export: 'Export',
    noData: 'No submissions found',
    noDataDescription: 'Submissions will appear here once the form is filled out',
    actions: 'Actions',
    submittedBy: 'Submitted by',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    results: 'results',
    submissionDetails: 'Submission Details',
    exportSuccess: 'Export successful',
    exportError: 'Export failed'
  }

};
